import React from "react"

export const PAYTM_TERMINAL_COLUMNS = [
  {
    Header: "Name",
    accessor: "name",
  },
  {
    Header: "Terminal ID",
    accessor: "terminalId",
  },
  {
    Header: "Description",
    accessor: "description",
  },
  {
    Header: "Appointment Types",
    accessor: (d: any) => d?.appointmentTypes?.join(", "),
  },
  {
    Header: "Is Default",
    accessor: "isDefault",
    Cell: (props: any) => {
      return props?.value ? (
        <span style={{ color: "green" }}>Yes</span>
      ) : (
        <span style={{ color: "red" }}> No</span>
      )
    }
  },
  {
    Header: "Status",
    accessor: "status",
    Cell: (props: any) => {
      console.log("props?.value", props)
      return props?.value?.toLowerCase() === "active" ? (
        <span style={{ color: "green" }}>Active</span>
      ) : (
        <span style={{ color: "red" }}> Inactive</span>
      )
    },
  },
  {
    Header: "",
    accessor: "Edit",
    Cell: () => (
      <img
        className="eye-icon"
        src={"../../../assets/images/CRedit.svg"}
        width={32}
        height={30}
        style={{
          marginTop: "6px",
          paddingRight: "15px",
          width: "40px",
          height: "40px",
        }}
        alt="eye"
      />
    ),
  },
]
